import React from "react";
import {
  Toolbar, Typography, Box, TextField, MenuItem, Button,
  FormControl, InputLabel, Select, InputAdornment
} from "@mui/material";
import { Search, FilterList } from "@mui/icons-material";
import PageHelp from "../../components/common/PageHelp";
import AppVersionFilter from "../../components/AppVersionFilter";
import { AppVersionOptions } from "../../hooks/useAppVersionOptions";

interface Props {
  searchTerm: string;
  setSearchTerm: (v: string) => void;
  roleFilter: string;
  setRoleFilter: (v: string) => void;
  statusFilter: string;
  setStatusFilter: (v: string) => void;
  appVersionFilter: string;
  setAppVersionFilter: (v: string) => void;
  appVersionOptions: AppVersionOptions;
}

/** Search box + role/status filters for the user list. */
const UserFiltersToolbar: React.FC<Props> = ({
  searchTerm, setSearchTerm, roleFilter, setRoleFilter, statusFilter, setStatusFilter,
  appVersionFilter, setAppVersionFilter, appVersionOptions,
}) => {
  const hasFilters = !!searchTerm || roleFilter !== 'all' || statusFilter !== 'all' || appVersionFilter !== 'all';
  return (
      <Toolbar sx={{ justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, flexShrink: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography variant="h6">User Management</Typography>
          <PageHelp k="users" />
        </Box>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
          <TextField
              placeholder="Search by phone, name, email…"
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                      <Search fontSize="small" color="action" />
                    </InputAdornment>
                ),
              }}
              sx={{ minWidth: 220 }}
          />
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Role</InputLabel>
            <Select
                value={roleFilter}
                label="Role"
                onChange={(e) => setRoleFilter(e.target.value)}
                startAdornment={<FilterList fontSize="small" sx={{ mr: 1, color: 'action.active' }} />}
            >
              <MenuItem value="all">All Roles</MenuItem>
              <MenuItem value="rider">Rider</MenuItem>
              <MenuItem value="driver">Driver</MenuItem>
              <MenuItem value="admin">Admin</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Status</InputLabel>
            <Select
                value={statusFilter}
                label="Status"
                onChange={(e) => setStatusFilter(e.target.value)}
            >
              <MenuItem value="all">All Status</MenuItem>
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="suspended">Suspended</MenuItem>
            </Select>
          </FormControl>
          <AppVersionFilter
              value={appVersionFilter}
              onChange={setAppVersionFilter}
              options={appVersionOptions}
          />
          {hasFilters && (
              <Button
                  variant="text"
                  size="small"
                  onClick={() => {
                    setSearchTerm("");
                    setRoleFilter("all");
                    setStatusFilter("all");
                    setAppVersionFilter("all");
                  }}
              >
                Clear
              </Button>
          )}
        </Box>
      </Toolbar>
  );
};

export default UserFiltersToolbar;
